<!-- Topbar Support Button -->
<button class="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle ms-1" (click)="openModal()" title="Open a support ticket">
	<i class="ri-customer-service-2-line fs-22"></i>
</button>

<!-- Capture overlay -->
<!-- TODO: re-enable capture overlay when image upload is ready
<div class="capture-overlay" *ngIf="isCapturing">
	<div class="capture-spinner">
		<div class="spinner-border text-light" role="status"></div>
		<p class="mt-2 text-white">Capturing screenshot...</p>
	</div>
</div>
-->

<!-- Modal -->
<div class="bug-report-overlay" *ngIf="isModalOpen" (click)="closeOnBackdrop($event)">
	<div class="bug-report-modal" #modalContainer>

		<!-- Header -->
		<div class="brm-header">
			<div class="brm-header-title">
				<i class="ri-customer-service-2-line me-2"></i>
				<span>Support Ticket</span>
			</div>
			<button class="brm-close" (click)="closeModal()">
				<i class="ri-close-line"></i>
			</button>
		</div>

		<!-- Priority -->
		<!-- TODO: re-enable priority selection when ready
		<div class="brm-priority-row">
			<div class="brm-priority-option brm-low" [class.selected]="priority === 'low'" (click)="priority = 'low'">
				<div class="brm-radio-dot" [class.active]="priority === 'low'"></div>
				<div class="brm-priority-text">
					<span class="brm-priority-label">Low</span>
					<span class="brm-priority-sub">Something's a little off.</span>
				</div>
			</div>
			<div class="brm-priority-option brm-medium" [class.selected]="priority === 'medium'" (click)="priority = 'medium'">
				<div class="brm-radio-dot" [class.active]="priority === 'medium'"></div>
				<div class="brm-priority-text">
					<span class="brm-priority-label">Medium</span>
					<span class="brm-priority-sub">I'm annoyed, but I'll live.</span>
				</div>
			</div>
			<div class="brm-priority-option brm-urgent" [class.selected]="priority === 'urgent'" (click)="priority = 'urgent'">
				<div class="brm-radio-dot" [class.active]="priority === 'urgent'"></div>
				<div class="brm-priority-text">
					<span class="brm-priority-label">Urgent</span>
					<span class="brm-priority-sub">I can't use the system.</span>
				</div>
			</div>
		</div>
		-->

		<!-- Body -->
		<div class="brm-body">
			<!-- Title -->
			<div class="brm-field">
				<input
					type="text"
					class="form-control"
					placeholder="Title — what went wrong?"
					[(ngModel)]="title"
					maxlength="150"
				/>
			</div>

			<!-- Description -->
			<div class="brm-field">
				<textarea
					class="form-control"
					rows="4"
					placeholder="I just thought you should know...&#10;(Describe the steps to reproduce, what you expected, and what actually happened)"
					[(ngModel)]="description"
				></textarea>
			</div>

			<!-- Screenshot section -->
			<!-- TODO: re-enable image upload / screenshot capture when ready
			<div class="brm-screenshot">
				<div class="brm-screenshot-preview" *ngIf="screenshotPreview">
					<img [src]="screenshotPreview" alt="Screenshot preview" />
					<button class="brm-screenshot-remove" (click)="clearScreenshot()" title="Remove screenshot">
						<i class="ri-close-circle-fill"></i>
					</button>
				</div>

				<div class="brm-screenshot-actions" *ngIf="!screenshotPreview">
					<label class="brm-screenshot-btn">
						<i class="ri-image-add-line me-1"></i> Upload Screenshot
						<input type="file" accept="image/*" (change)="onFileSelected($event)" style="display:none" />
					</label>
					<button class="brm-screenshot-btn brm-capture-btn" (click)="captureScreenshot()">
						<i class="ri-camera-line me-1"></i> Capture Screen
					</button>
				</div>
			</div>
			-->
		</div>

		<!-- Footer -->
		<div class="brm-footer">
			<button class="btn btn-light btn-sm" (click)="closeModal()">Cancel</button>
			<button
				class="btn btn-primary btn-sm"
				(click)="submitTicket()"
				[disabled]="isSubmitting || !title.trim()"
			>
				<span *ngIf="isSubmitting" class="spinner-border spinner-border-sm me-1" role="status"></span>
				<span *ngIf="!isSubmitting"><i class="ri-send-plane-line me-1"></i></span>
				{{ isSubmitting ? 'Submitting...' : 'Submit Ticket' }}
			</button>
		</div>

	</div>
</div>
